import { FC, SVGProps, useMemo } from "react";
import { DateController } from "src/app/tools/dates/date.tool";
import { useNavigationFeature } from "src/app/features/navigation/navigation.feature";
import { useVersionFeature } from "src/app/features/version.feature";
import { ButtonUI } from "src/app/ui/buttons/button.ui";
import { useSalesDomain } from "../sales/sales.domain";

type LogoProps = SVGProps<SVGSVGElement>;

export const LogoUI: FC<LogoProps> = (props) => {
  const { getCurrentVersion, getEnvironment, getLastDeployDate } =
    useVersionFeature();
  const { getCurrentPack } = useSalesDomain();
  const { goto } = useNavigationFeature();

  const dateCtrl = useMemo(() => new DateController(getLastDeployDate()), []);

  return (
    <div className="item-center flex justify-center">
      <svg
        style={{
          position: "relative",
          top: "3px",
        }}
        fill="none"
        viewBox="0 0 157 28"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M.186 13.629a9.278 9.278 0 0 0 7.264 7.227c.619.127 1.26.194 1.916.194.47 0 .853-.034 1.164-.1 4.525-.613 8.013-4.489 8.013-9.179 0-4.798-3.652-8.744-8.33-9.216a6.76 6.76 0 0 0-.942-.047C4.151 2.508 0 6.655 0 11.77a9.582 9.582 0 0 0 0 .008c0 .633.064 1.252.186 1.85Zm11.446 5.792c-.102-.605-.427-1.357-.8-2.22-.658-1.525-1.466-3.398-1.466-5.422 0-2.024.808-3.896 1.466-5.42.425-.986.788-1.826.829-2.467 3.252 1.032 5.613 4.116 5.613 7.76 0 3.655-2.375 6.746-5.642 7.769Z"
          fill="currentColor"
        />
        <path
          d="M38.73 6.932c-1.989 0-3.531 1.027-4.302 2.705-.622-1.703-2.164-2.755-4.079-2.705-1.741 0-3.134.877-3.88 2.43v-2.18h-1.393v12.094h1.418V12.14c0-2.303 1.542-3.98 3.631-3.98 2.015 0 3.333 1.502 3.333 3.955v7.161h1.418v-7.16c0-2.304 1.567-3.957 3.63-3.957 2.04 0 3.334 1.478 3.334 3.956v7.161h1.417V11.99c0-3.18-1.766-5.058-4.526-5.058ZM57.114 12.816c0-3.505-2.114-5.884-5.372-5.884-3.283 0-5.77 2.755-5.77 6.285 0 3.656 2.536 6.31 6.068 6.31 1.84 0 3.432-.626 4.577-1.803l-.771-.927c-1.02 1.027-2.289 1.503-3.781 1.503-2.711 0-4.601-2.003-4.7-4.908h9.749v-.576Zm-9.675-.55c.348-2.379 2.04-4.132 4.278-4.132 2.288 0 3.855 1.603 4.004 4.132H47.44ZM73.663 6.932c-1.99 0-3.532 1.027-4.303 2.705-.622-1.703-2.164-2.755-4.079-2.705-1.74 0-3.134.877-3.88 2.43v-2.18h-1.393v12.094h1.418V12.14c0-2.303 1.542-3.98 3.631-3.98 2.015 0 3.333 1.502 3.333 3.955v7.161h1.418v-7.16c0-2.304 1.567-3.957 3.631-3.957 2.04 0 3.333 1.478 3.333 3.956v7.161h1.418V11.99c0-3.18-1.766-5.058-4.527-5.058ZM87.022 19.527c3.532 0 6.094-2.755 6.094-6.31 0-3.555-2.562-6.285-6.094-6.285-3.581 0-6.118 2.73-6.118 6.285s2.537 6.31 6.118 6.31Zm0-1.227c-2.736 0-4.7-2.128-4.7-5.083s1.964-5.058 4.7-5.058c2.686 0 4.676 2.103 4.676 5.058 0 2.955-1.99 5.083-4.676 5.083ZM97.403 19.276v-7.06c0-2.003 1.318-3.856 3.805-3.856.373 0 .821.05 1.144.125V7.133a6.814 6.814 0 0 0-1.094-.075c-1.94 0-3.308 1.026-3.88 2.478V7.183h-1.393v12.093h1.418ZM107.398 19.527c1.89 0 3.507-1.002 4.303-2.554.025 1.126.149 1.702.572 2.303h1.467c-.547-.826-.696-1.477-.696-2.88v-5.583c0-2.428-1.666-3.88-4.452-3.88-1.94 0-3.557.625-4.75 1.902l.87.902c1.045-1.077 2.313-1.578 3.805-1.578 1.965 0 3.159.977 3.159 2.58 0 1-.597 1.451-2.263 1.677l-1.816.275c-2.785.376-4.153 1.527-4.153 3.48 0 2.079 1.467 3.356 3.954 3.356Zm.174-1.227c-1.716 0-2.736-.826-2.736-2.179 0-1.327.97-2.053 2.985-2.353l1.791-.25c1.094-.15 1.666-.376 2.064-.827v1.653c0 2.278-1.741 3.956-4.104 3.956ZM122.803 19.527c3.382 0 5.869-2.654 5.869-6.31 0-3.656-2.487-6.285-5.869-6.285-2.065 0-3.781 1.127-4.701 2.98V2h-1.418v17.276h1.393v-2.629c.945 1.803 2.612 2.88 4.726 2.88Zm-.15-1.227c-2.636 0-4.576-2.154-4.576-5.083 0-2.904 1.94-5.058 4.576-5.058 2.662 0 4.602 2.154 4.602 5.058 0 2.93-1.94 5.083-4.602 5.083ZM132.969 19.276V2h-1.417v17.276h1.417ZM147 12.816c0-3.505-2.114-5.884-5.372-5.884-3.283 0-5.77 2.755-5.77 6.285 0 3.656 2.537 6.31 6.068 6.31 1.841 0 3.433-.626 4.577-1.803l-.771-.927c-1.02 1.027-2.288 1.503-3.781 1.503-2.711 0-4.601-2.003-4.7-4.908H147v-.576Zm-9.675-.55c.348-2.379 2.04-4.132 4.278-4.132 2.288 0 3.855 1.603 4.004 4.132h-8.282Z"
          fill="currentColor"
        />
      </svg>
      {getCurrentPack() && (
        <ButtonUI
          type="text"
          title={
            <div>
              <small>
                {getEnvironment()} {`${getCurrentVersion()}`} (
                {dateCtrl.relativeTime()})
              </small>
            </div>
          }
          onClick={() => {
            goto("/changelog");
          }}
          style={{
            background: "#F5F5F5",
            padding: "7px",
            borderRadius: "4px",
            display: "flex",
            alignItems: "center",
            fontSize: "0.8rem",
          }}
        >
          {getCurrentPack()?.toUpperCase()}
        </ButtonUI>
      )}
    </div>
  );
};
